'use client'

import { Button } from '@snowball-tech/fractal/dist/src/components/Button'
import { UilBars as HamburgerMenuIcon } from '@tooni/iconscout-unicons-react'
import dynamicImport from 'next/dynamic'

import { useCallback, useEffect, useState } from 'react'

import type { ChildrenProps } from '../../types'

import { usePathname } from '../../helpers/translations'
import useMediaQuery from '../../hooks/useMediaQuery'
import useTranslations from '../../hooks/useTranslations'

const MobileMenuPanel = dynamicImport(() => import('./MobileMenuPanel'), {
  ssr: false,
})

type Props = {
  isConnected?: boolean
} & Partial<ChildrenProps>
export default function MobileMenu({ children, isConnected = false }: Props) {
  const $t = useTranslations()
  const pathname = usePathname
  const mediaQueries = useMediaQuery()

  const [isMobileMenuVisible, setIsMobileMenuVisible] = useState(false)
  const hideMobileMenu = useCallback(() => setIsMobileMenuVisible(false), [])
  const toggleMobileMenu = () =>
    setIsMobileMenuVisible((wasMobileMenuVisible) => !wasMobileMenuVisible)

  useEffect(() => {
    hideMobileMenu()
  }, [hideMobileMenu, pathname])

  useEffect(() => {
    if (mediaQueries.fromLg) {
      hideMobileMenu()
    }
  }, [hideMobileMenu, mediaQueries.fromLg])

  useEffect(() => hideMobileMenu, [hideMobileMenu])

  return (
    <div className="lg:hidden">
      <Button
        icon={<HamburgerMenuIcon />}
        iconOnly
        label={$t('general.menu')}
        variant="display"
        onClick={toggleMobileMenu}
      />

      <MobileMenuPanel
        close={hideMobileMenu}
        isConnected={isConnected}
        toggle={toggleMobileMenu}
        visible={isMobileMenuVisible}
      >
        {children}
      </MobileMenuPanel>
    </div>
  )
}
